(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
  var loadRelatedProductsIntoSection = function () {
    // Look for an element with class 'related-products'
    var relatedProductsSection = document.querySelector('.related-products')
    if (relatedProductsSection === null) {
      return
    }
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest()
    request.open('GET', relatedProductsSection.dataset.url)
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div')
        container.innerHTML = request.response
        relatedProductsSection.innerHTML = container.querySelector('.related-products').innerHTML
        theme.initAnimateOnScroll()
        document.dispatchEvent(
          new CustomEvent('product-card-ajaxed', { detail: { container: relatedProductsSection } })
        )
      }
    }
    request.send()
  }
  // Fetch when section reloads in editor
  document.addEventListener('shopify:section:load', function (event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
      loadRelatedProductsIntoSection()
    }
  })
  // Fetch the products on page load
  loadRelatedProductsIntoSection()

  } catch(e) { console.error(e); }
})();
})();
